//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export interface IStorageValue {
  value: unknown;
  expires: Date;
}

// This can be extended to include support for any action taken
// on any feature on the Dashboard, and can be arbitrarily specific
// depending on the use-case (e.g. this can refer to a top-level
// feature or a specific component in the UI).
export enum FeatureStorageScope {
  CAMPAIGNS_CREATORS_CAMPAIGN_REQUESTS_TABLE_EXPANDED = 'campaigns-creators-campaign-requests-table-expanded',
  CAMPAIGNS_SAMPLING_CAMPAIGN_REQUESTS_TABLE_EXPANDED = 'campaigns-sampling-campaign-requests-table-expanded',
  COPIED_ONE_PAGE_LINK = 'copied-one-page-link',
  HARMONY_AI_FILTER_CACHE = 'harmony-ai-filter-cache',
  REMIND_ME_LATER_ADOBE_ANALYTICS_MEDIA_WARNING = 'remind-me-later-adobe-analytics-media-warning',
  REMIND_ME_LATER_DELAYED_TIKTOK_METRICS = 'remind-me-later-delayed-tiktok-metrics-warning',
  REMIND_ME_LATER_INSIGHTS_GA4_MIGRATION_WARNING = 'remind-me-later-insights-ga4-migration-warning',
  REMIND_ME_LATER_MADE_FOR_KIDS = 'remind-me-later-made-for-kids',
  REMIND_ME_LATER_NO_GALLERIES_ANALYTICS_PROVIDER_WARNING = 'remind-me-later-no-galleries-analytics-provider-warning',
  REMIND_ME_LATER_NO_GALLERIES_WARNING = 'remind-me-later-no-galleries-warning',
  REMIND_ME_LATER_NO_LIKE2BUY_WARNING = 'remind-me-later-no-like2buy-warning',
  REMIND_ME_LATER_NO_REVEALS_WARNING = 'remind-me-later-no-reveals-warning',
  REMIND_ME_LATER_NO_SHOWROOMS_WARNING = 'remind-me-later-no-showrooms-warning',
  REMIND_ME_LATER_REVEAL_ECOM_ALERT = 'remind-me-later-reveal-ecom-alert',
  REMIND_ME_LATER_SAME_DAY_METRICS_WARNING = 'remind-me-later-same-day-metrics-warning',
  REMIND_ME_LATER_SUMMARY_ADOBE_ANALYTICS_MEDIA_WARNING = 'remind-me-later-summary-adobe-analytics-media-warning',
  REMIND_ME_LATER_SUMMARY_GOOGLE_ANALYTICS_MEDIA_WARNING = 'remind-me-later-summary-google-analytics-media-warning',
  REMIND_ME_LATER_UNMODERATED_TBC_CONTENT = 'remind-me-later-unmoderated-tbc-content',
  SCHEDULE_FEED_PREVIEW_HIDE_INFO_ALERT = 'schedule-feed-preview-hide-info-alert',
  STARTED_BULK_SELECTION = 'started-bulk-selection',
}
